import * as React from 'react';
import Plyr from "plyr-react"
import "plyr-react/plyr.css"

export interface IVideoPlayerProps {
    plyrProps: any
}

const VideoPlayer = ({ plyrProps }: IVideoPlayerProps) => {

    return (
        <div className="overflow-visible">
            {React.useMemo(() => <Plyr {...plyrProps} />, [])}
        </div>
    );
}


export default VideoPlayer;